export default "__VITE_ASSET__DX3ra4Qr__"